<template>
    <div>
        <div class="mt-4 mb-8 space-y-2">
            <h2 class="text-3xl font-bold text-white">
                Reset your password
            </h2>
            <h3 class="text-sm text-gray-300">
                Choose a new and secure password for your account.
            </h3>
        </div>

        <form action="#" @submit.prevent="onSubmit">
            <div class="space-y-6">
                <UFormGroup label="New password" :error="error">
                    <UInput 
                        ref="passwordInput" 
                        v-model="form.password"
                        type="password" 
                        size="xl" 
                        required
                    />
                </UFormGroup>
                <UFormGroup label="Confirm password" :error="!!error">
                    <UInput 
                        ref="passwordConfirmationInput" 
                        v-model="form.password_confirmation"
                        type="password" 
                        size="xl" 
                        required
                    />
                </UFormGroup>
            </div>

            <UButton block type="submit" size="xl" :loading="loading" color="black" class="mt-8">
                Submit
            </UButton>
        </form>

        <div class="mt-6 text-center">
            <UButton to="/" variant="link" color="black">
                Cancel
            </UButton>
        </div>
    </div>
</template>

<script setup lang="ts">
definePageMeta({ layout: 'auth', middleware: 'auth' })
useHead({ title: 'Reset Password' })

const loading = ref<boolean>(false)
const error = ref<string>()
const passwordInput = ref()

const form = ref({
    password: '',
    password_confirmation: '',
})

async function onSubmit() {
    loading.value = true

    try {
        if (form.value.password !== form.value.password_confirmation) {
            throw new Error('Passwords do not match.')
        }

        await $fetch('/api/auth/password/reset', {
            method: 'POST',
            body: form.value
        })

        navigateTo('/')
    } catch (e: any) {
        showError(e?.data?.message || e.message)
    } finally {
        loading.value = false
    }
}

function showError(message: string) {
    passwordInput.value?.$refs.input.focus()
    error.value = message
}
</script>
